export const INSIGHTS_STORAGE_KEY: string = 'InsightsMemory'
